<template>
  <div class="min-h-screen flex flex-col items-center justify-center text-center">
    <div>
      <ProgressSpinner stroke-width="4" />
      <p>Logging out...</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import ProgressSpinner from "primevue/progressspinner";
import { useAuthStore } from "@/store/auth.ts";

const authStore = useAuthStore();

onMounted(async () => {
  await authStore.logout();
});

definePage({
  meta: {
    title: 'Log out',
    public: false
  }
})
</script>
